<template>
  <div>
    <s-crud
      :config="config"
      title="Peligros y Recomendaciones SST"
      :filter="filter"
      add
      edit
      remove
      ref="ScrudDangerSST"
      @save="save($event)"
      @rowSelected="rowSelected($event)"
      searchInput
    >
      <template v-slot:options>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              small
              elevation="0"
              :loading="downloadingTemplate"
              @click="downloadTemplate"
            >
              <v-icon color="success" x-small> fas fa-file-excel </v-icon>
            </v-btn>
          </template>
          <span>Descargar Plantilla Excel</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" small elevation="0" @click="openBulkModal">
              <v-icon color="primary" x-small> fas fa-file-upload </v-icon>
            </v-btn>
          </template>
          <span>Carga Masiva Excel</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" small elevation="0" @click="duplicate">
              <v-icon color="default" x-small> fas fa-copy </v-icon>
            </v-btn>
          </template>
          <span>Duplicar</span>
        </v-tooltip>
      </template>
      <template v-slot="props">
        <v-container>
          <v-row>
            <v-col cols="6" class="s-col-form">
              <s-select-area
                v-model="props.item.AreID"
                :text="props.item.AreName"
                label="Área"
              />
            </v-col>
            <v-col cols="6" class="s-col-form">
              <s-select-position
                label="Cargo"
                v-model="props.item.PstID"
                :text="props.item.PstName"
                :AreID="props.item.AreID"
                style="margin-top: -2px"
              ></s-select-position>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </s-crud>
    <br />
    <v-card>
      <v-tabs v-model="tab" centered height="35">
        <v-tab href="#tabPeligros"> Peligros </v-tab>
        <v-tab href="#tabRecommendation"> Recomendaciones </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item :value="'tabPeligros'">
          <v-card class="pa-4">
            <v-row justify="center">
              <v-col md="12" lg="12" sm="12">
                <danger-sst-hazard
                  ref="dangerSstHazard"
                  :DgsID="selected"
                  @reload="reload()"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>

        <v-tab-item :value="'tabRecommendation'">
          <v-card class="pa-4">
            <v-row justify="center">
              <v-col md="12" lg="12" sm="12">
                <danger-sst-recommendation
                  ref="dangerSstRecommendation"
                  :DgsID="selected"
                  @reload="reload()"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Dialog Duplicar -->
    <v-dialog v-model="OpenDialog" persistent width="500">
      <s-toolbar
        label="Duplicar Registro"
        close
        @close="OpenDialog = false"
        color="#BAB6B5"
        dark
      ></s-toolbar>
      <v-card>
        <v-container>
          <v-row style="height: 60px">
            <v-col cols="6" class="s-col-form">
              <s-select-area v-model="AreID" :text="AreName" label="Área" />
            </v-col>
            <v-col cols="6" class="s-col-form">
              <s-select-position
                label="Cargo"
                v-model="PstID"
                :text="PstName"
                :AreID="AreID"
                style="margin-top: -2px"
              ></s-select-position>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="primary" block @click="saveDuplicate()">
                Guardar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog Carga Masiva Excel -->
    <v-dialog v-model="OpenBulkDialog" persistent width="650">
      <s-toolbar
        label="Carga Masiva de Matriz IPERC (SST)"
        close
        @close="closeBulkModal"
        color="primary"
        dark
      ></s-toolbar>
      <v-card class="pa-4">
        <v-alert
          dense
          outlined
          type="info"
          class="mb-4 text-caption"
        >
          <strong>Instrucciones:</strong>
          <ul class="pl-4 mt-1">
            <li>Descargue la plantilla oficial usando el botón <strong>"Descargar Plantilla Excel"</strong>.</li>
            <li>La plantilla contiene 2 hojas principales: <strong>"Peligros y Riesgos"</strong> y <strong>"Recomendaciones"</strong>.</li>
            <li>Utilice los selectores desplegables incluidos en la plantilla para asegurar el formato correcto.</li>
            <li>El proceso se ejecuta en <strong>segundo plano</strong> y le notificará al concluir.</li>
          </ul>
        </v-alert>

        <v-file-input
          v-model="bulkFile"
          label="Seleccionar archivo Excel (.xlsx)"
          accept=".xlsx, .xls"
          outlined
          dense
          prepend-icon="fas fa-file-excel"
          show-size
          placeholder="Haga clic para adjuntar el archivo"
        ></v-file-input>

        <v-switch
          v-model="overwriteExisting"
          label="Sobrescribir matriz existente si ya existe el Área y Cargo"
          color="primary"
          dense
          inset
          class="mt-0"
        ></v-switch>

        <v-divider class="my-3"></v-divider>

        <v-row justify="end" class="px-2">
          <v-btn text @click="closeBulkModal" :disabled="uploadingBulk" class="mr-2">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="uploadingBulk"
            :disabled="!bulkFile"
            @click="submitBulk"
          >
            <v-icon left small>fas fa-cloud-upload-alt</v-icon>
            Procesar Carga Masiva
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _sDangerSST from "../../../../services/HumanResource/HmnDangerSSTService";
import dangerSstHazard from "./DangerSSTHazard.vue";
import dangerSstRecommendation from "./DangerSSTRecommendation.vue";

export default {
  components: {
    dangerSstHazard,
    dangerSstRecommendation,
  },
  data() {
    return {
      filter: {},
      selected: null,
      tab: "tabPeligros",
      DgsID: 0,
      OpenDialog: false,
      AreID: null,
      AreName: null,
      PstID: null,
      PstName: null,
      // Carga masiva
      OpenBulkDialog: false,
      bulkFile: null,
      overwriteExisting: true,
      uploadingBulk: false,
      downloadingTemplate: false,
      config: {
        service: _sDangerSST,
        model: {
          DgsID: "ID",
          AreName: "string",
          PstName: "string",
        },
        headers: [
          { text: "ID", value: "DgsID" },
          { text: "Área", value: "AreName" },
          { text: "Cargo", value: "PstName" },
        ],
      },
    };
  },
  mounted() {
    this.setupSignalRListener();
  },
  beforeDestroy() {
    this.removeSignalRListener();
  },
  methods: {
    setupSignalRListener() {
      this.onSignalRMessage = (event) => {
        const { message } = (event && event.detail) || {};
        if (!message) return;
        let payload = message;
        if (typeof message === "string") {
          try {
            payload = JSON.parse(message);
          } catch (e) {}
        }
        if (payload && payload.type === "DANGER_SST_IMPORT_COMPLETED") {
          this.$fun.alert(
            `Importación completada: ${payload.matrixCount || 0} matrices, ${payload.hazardsCount || 0} peligros y ${payload.recommendationsCount || 0} recomendaciones procesadas exitosamente.`,
            "success"
          );
          this.reload();
        } else if (payload && payload.type === "DANGER_SST_IMPORT_ERROR") {
          this.$fun.alert(
            payload.message || "Ocurrió un error durante la importación masiva.",
            "error"
          );
        }
      };
      if (typeof window !== "undefined") {
        window.addEventListener("signalr-message-group", this.onSignalRMessage);
      }
    },
    removeSignalRListener() {
      if (typeof window !== "undefined" && this.onSignalRMessage) {
        window.removeEventListener(
          "signalr-message-group",
          this.onSignalRMessage
        );
      }
    },
    save(item) {
      item.save();
    },
    rowSelected(item) {
      if (
        item &&
        Array.isArray(item) &&
        item.length > 0 &&
        item[0] &&
        item[0].DgsID !== undefined
      ) {
        this.selected = item[0].DgsID;
      } else {
        this.selected = null;
      }
    },
    duplicate() {
      if (this.selected) {
        this.OpenDialog = true;
      }
    },
    saveDuplicate() {
      if (!this.AreID || !this.PstID) {
        this.$fun.alert("Seleccione Área y Cargo", "warning");
        return;
      }

      const obj = {
        DgsID: this.selected,
        AreID: this.AreID,
        PstID: this.PstID,
        UsrCreateID: this.$fun.getUserID(),
      };

      this.$fun
        .alert("¿Está seguro de duplicar el registro seleccionado?", "question")
        .then((val) => {
          if (val.value) {
            _sDangerSST
              .duplicate(obj, this.$fun.getUserID())
              .then((r) => {
                this.$fun.alert("Registro duplicado correctamente", "success");
                this.reload();
                this.OpenDialog = false;
              })
              .catch((error) => {
                //console.log(error);
              });
          }
        });
    },
    async downloadTemplate() {
      this.downloadingTemplate = true;
      try {
        const response = await _sDangerSST.downloadTemplate(
          this.$fun.getUserID()
        );
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Plantilla_Matriz_IPERC_SST.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        let errorMsg = "Error al descargar la plantilla Excel";
        if (error && error.response && error.response.data) {
          if (error.response.data instanceof Blob) {
            try {
              const text = await error.response.data.text();
              try {
                const parsed = JSON.parse(text);
                errorMsg = parsed.Message || parsed.message || (typeof parsed === "string" ? parsed : text);
              } catch (e) {
                if (text) errorMsg = text;
              }
            } catch (e) {}
          } else if (error.response.data.Message) {
            errorMsg = error.response.data.Message;
          }
        }
        this.$fun.alert(errorMsg, "error");
      } finally {
        this.downloadingTemplate = false;
      }
    },
    openBulkModal() {
      this.bulkFile = null;
      this.overwriteExisting = true;
      this.OpenBulkDialog = true;
    },
    closeBulkModal() {
      if (!this.uploadingBulk) {
        this.OpenBulkDialog = false;
        this.bulkFile = null;
      }
    },
    async submitBulk() {
      if (!this.bulkFile) {
        this.$fun.alert("Por favor seleccione un archivo Excel.", "warning");
        return;
      }

      this.uploadingBulk = true;
      try {
        const formData = new FormData();
        formData.append("file", this.bulkFile);

        const res = await _sDangerSST.uploadBulk(
          formData,
          this.$fun.getUserID(),
          this.overwriteExisting
        );

        if (res && res.data && res.data.success) {
          this.$fun.alert(
            res.data.message || "¡Matriz IPERC procesada exitosamente!",
            "success"
          );
          this.OpenBulkDialog = false;
          this.bulkFile = null;
          this.reload();
        } else {
          this.$fun.alert(
            (res && res.data && res.data.message) ||
              "Ocurrió un error al procesar el archivo.",
            "error"
          );
        }
      } catch (error) {
        let msg = "Error de comunicación al subir el archivo masivo.";
        if (error && error.response && error.response.data) {
          msg = error.response.data.Message || error.response.data.message || (typeof error.response.data === "string" ? error.response.data : msg);
        }
        this.$fun.alert(msg, "error");
      } finally {
        this.uploadingBulk = false;
      }
    },
    reload() {
      this.$refs.ScrudDangerSST.refresh();
    },
  },
};
</script>
